<!-- <template>
  <v-alert
    dense
    class="my-2"
    icon="mdi-bullhorn"
    style="background-image: linear-gradient(90deg, rgba(27,124,59,1) 0%, rgba(102,142,31,1) 48%, rgba(191,156,24,1) 89%);"
  >
    <v-row no-gutters class="align-center">
      <v-col class="grow text-body-2">
        ร่วมเป็นส่วนหนึ่งในการพัฒนาชุมชน Repttown
      </v-col>
      <v-col class="shrink">
        <v-btn small outlined color="white" to="/#feedbacks">ได้ที่นี่</v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template> -->

<template>
  <v-alert dense class="my-2 announcement" icon="mdi-bullhorn">
    <v-row no-gutters class="align-center">
      <v-col class="grow text-body-2">
        ใช้งาน New Repttown
      </v-col>
      <v-col class="shrink">
        <v-btn small outlined color="white" :href="newVersionUrl">
          ได้ที่นี่
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
export default {
  name: "Announcement",
  computed: {
    newVersionUrl() {
      // eg. /classic/product/1 -> /product/1
      return this.$route.path.replace("/classic", "")
    },
  },
}
</script>

<style>
.announcement {
  background: radial-gradient(
    800px at 65% 85%,
    rgb(149, 151, 172) 0%,
    rgb(47, 47, 56) 97.5%
  );
  /* background: linear-gradient(30deg, rgb(52, 113, 70) 0%, rgb(229, 193, 93) 90%); */
  /* background: linear-gradient(87.4deg, rgb(255, 241, 165) 1.9%, rgb(200, 125, 76) 49.7%, rgb(83, 54, 54) 100.5%); */
  /* background: linear-gradient(147.4deg, rgb(250, 246, 213) 0.1%, rgb(218, 147, 93) 42.2%, rgb(137, 86, 67) 74.3%, rgb(67, 39, 39) 100.2%); */
}
</style>
